import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import ErroreIcon from '../Icons/ErroreIcon';

const ValidationViewer = ({
  hasError, hasWarning, validazione, className,
}) => (
  <Fragment>
    {hasError && (
      <ul className="validationViewer__errors">
        {validazione.messages.map(
          (x, i) => <li key={i}>{x}</li>, // eslint-disable-line
        )}
      </ul>
    )}
    {hasError && <span className={cns('validationViewer__icon-error', className)}><ErroreIcon /></span>}
    {hasWarning && (
      <ul className={cns('validationViewer__warnings', className)}>
        {validazione.warnings.map(
          (x, i) => <li key={i}>{x}</li>, // eslint-disable-line
        )}
      </ul>
    )}
    {hasWarning && <span className="validationViewer__icon-warning"> <ErroreIcon /></span>}
  </Fragment>
);

ValidationViewer.propTypes = {
  className: PropTypes.string,
  hasError: PropTypes.bool,
  hasWarning: PropTypes.bool,
  validazione: PropTypes.shape({
    messages: PropTypes.arrayOf(PropTypes.string),
    warnings: PropTypes.arrayOf(PropTypes.string),
    valid: PropTypes.bool,
  }).isRequired,
};

ValidationViewer.defaultProps = {
  hasError: false,
  hasWarning: false,
  className: undefined,
};

export default ValidationViewer;
